import "./App.css";

export default function App() {
  return (
    <main className="launch-page">
      <div className="ambient ambient-one" />
      <div className="ambient ambient-two" />

      <section className="launch-card">
        <div className="brand">
          <span className="brand-mark">✦</span>
          <span>uselessEngineer.dev</span>
        </div>

        <div className="status">
          <span className="status-dot" />
          <span>Something new is coming</span>
        </div>

        <h1>
          We're launching
          <span> soon.</span>
        </h1>

        <p className="description">
          We're building something thoughtful, powerful, and a little different.
          Stay tuned — the future is almost ready.
        </p>

        <div className="orb">
          <div className="orb-core" />
          <div className="orb-ring ring-one" />
          <div className="orb-ring ring-two" />
          <div className="orb-ring ring-three" />
        </div>

        <div className="launch-line">
          <span />
          <span>Launching soon</span>
          <span />
        </div>
      </section>

      <footer>© {new Date().getFullYear()} GREEVSTACK</footer>
    </main>
  );
}
